import styles from './index.module.css'

import React from 'react'
import { Link } from 'react-router-dom'

import { LuChevronRight } from '@react-icons/all-files/lu/LuChevronRight'

interface SeeAllLinkProps {
  to?: string
  href?: string
  label?: string
}

const SeeAllLink = ({
  to,
  href,
  label = 'See all',
}: SeeAllLinkProps): React.ReactNode => {
  const content = (
    <>
      <span>{label}</span>
      <LuChevronRight size={16} />
    </>
  )

  if (to) {
    return (
      <Link to={to} className={styles.seeAllLink}>
        {content}
      </Link>
    )
  }

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.seeAllLink}
        aria-label={`${label} (opens in new tab)`}
      >
        {content}
      </a>
    )
  }

  return null
}

export default SeeAllLink
